import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Menu from "../Menu";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircleIcon from '@mui/icons-material/Circle';

const ROC = () => {
  const [selectedMenu, setSelectedMenu] = useState<string>('Company & LLP Incorporation');
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = [
    'Company & LLP Incorporation',
    'Annual Compliance & Filings',
    'Share Issuance & Capital Changes',
    'Statutory Registers & Record Maintenance',
    'Certifications & Legal Advisory',
    'Drafting Services',
    'Winding Up & Closure Services'
  ];

  const renderContent = () => {
    switch (selectedMenu) {
      case 'Company & LLP Incorporation':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Company & LLP Incorporation
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Name approval and reservation" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Preparation of Memorandum & Articles of Association (MOA & AOA)" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Filing incorporation forms with MCA" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Issuance of Certificate of Incorporation" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Drafting partnership deeds for LLPs" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Obtaining DIN and DSC" /></ListItem>
            </List>
          </Box>
        );
      case 'Annual Compliance & Filings':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Annual Compliance & Filings
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Preparation and filing of annual returns (MGT-7, AOC-4, LLP Form 11)" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Drafting Board and General Meeting resolutions" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Director KYC submission (DIR-3 KYC)" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Conducting secretarial audits" /></ListItem>
            </List>
          </Box>
        );
      case 'Share Issuance & Capital Changes':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Share Issuance & Capital Changes
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Rights issue of shares" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Private placement & preferential issue" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Increase of authorized capital" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Name changes of the company" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Conversion of Private Limited to Public Limited Company" /></ListItem>
            </List>
          </Box>
        );
      case 'Statutory Registers & Record Maintenance':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Statutory Registers & Record Maintenance
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Maintaining registers of directors, shareholders, and members" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Register of charges, investments, loans, and contracts" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Preparation of minutes books for Board & Committee meetings" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Share certificate issuance and transfer record maintenance" /></ListItem>
            </List>
          </Box>
        );
      case 'Certifications & Legal Advisory':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Certifications & Legal Advisory
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Secretarial compliance certification (Form MGT-8)" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Professional certifications for ROC filings" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Corporate restructuring advisory" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Due diligence reports and legal documentation" /></ListItem>
            </List>
          </Box>
        );
      case 'Drafting Services':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Drafting Services
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Drafting of AGM, EGM, Board, and Committee minutes" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Preparation of Directors' Reports, Agendas, Notices, Chairman's Speech" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Drafting of Shareholders Agreements (SHA, SHPA, etc.)" /></ListItem>
            </List>
          </Box>
        );
      case 'Winding Up & Closure Services':
        return (
          <Box>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Winding Up & Closure Services
            </Typography>
            <List>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Voluntary winding up of companies and LLPs" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Filing necessary resolutions and closure forms" /></ListItem>
              <ListItem><ListItemIcon><CircleIcon sx={{ fontSize: 8 }} /></ListItemIcon><ListItemText primary="Guidance through liquidation processes and regulatory compliance" /></ListItem>
            </List>
          </Box>
        );
      default:
        return <Typography>Select a service to view details.</Typography>;
    }
  };

  return (
    <div ref={contentContainerRef}>
      {/* Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), 
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography variant="h3">ROC Services</Typography>
        </Box>
      </Box>

      {/* Intro Text */}
      <Box sx={{ padding: "60px 40px 20px", backgroundColor: "#fff", color: "#000" }}>
        <Box sx={{ maxWidth: "900px", margin: "0 auto", mb: 6 }}>
          <Typography variant="h5" fontWeight="bold" align="center" gutterBottom sx={{ fontSize: { xs: '26px', md: '32px' }, mb: 3 }}>
            ROC Compliance Solutions
          </Typography>
          <Typography variant="body1" align="left">
            We specialize in providing end-to-end solutions for businesses seeking seamless compliance with ROC regulations. Our services encompass company incorporation, LLP registration, annual compliance, statutory record maintenance, and professional certifications, ensuring legal adherence.
          </Typography>
        </Box>
      </Box>

      {/* Sections */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'start',
          minHeight: '100vh',
          backgroundColor: '#fff',
          padding: '40px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            maxWidth: '1200px',
          }}
        >
          {/* Left Menu */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '350px',
              backgroundColor: '#a3d133',
              position: 'sticky',
              top: 0,
              overflowY: 'auto',
            }}
          >
            {menuItems.map((item) => (
              <Box
                key={item}
                onClick={() => setSelectedMenu(item)}
                sx={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  fontFamily: 'Arial, sans-serif',
                  color: selectedMenu === item ? '#fff' : '#000',
                  padding: '20px 30px',
                  cursor: 'pointer',
                  backgroundColor: selectedMenu === item ? '#7a9f26' : '#a3d133',
                  borderBottom: '10px solid #fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  '&:hover': { backgroundColor: '#8fb029' },
                }}
              >
                {item}
                <ArrowForwardIosIcon
                  sx={{
                    fontSize: '16px',
                    color: selectedMenu === item ? '#fff' : '#000',
                  }}
                />
              </Box>
            ))}
          </Box>

          {/* Right Content */}
          <Box
            sx={{
              flexGrow: 1,
              padding: '40px',
              backgroundColor: '#fff',
              color: '#333',
              overflowY: 'auto',
              maxHeight: '100vh',
            }}
          >
            {renderContent()}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default ROC;
